var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebDeveloper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 306,
    viewBox: "0 0 406 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_417)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M381.633 11.3319H57.1388C52.5886 11.3319 48.8999 15.0206 48.8999 19.5708V221.493C48.8999 226.044 52.5886 229.732 57.1388 229.732H381.633C386.183 229.732 389.872 226.044 389.872 221.493V19.5708C389.872 15.0206 386.183 11.3319 381.633 11.3319Z",
    fill: "#FFC063"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M383.124 245.676C382.875 252.829 381.237 260.111 377.232 266.039C372.188 273.505 363.995 278.126 356.06 282.471L333.561 294.852C323.702 300.283 313.309 305.844 302.069 306C294.116 306.12 286.42 303.496 278.77 301.296C243.044 290.986 205.412 289.541 168.479 292.146C149.562 293.481 130.737 295.828 111.994 298.654C96.9986 300.882 79.0018 308.292 65.4789 299.519C50.7501 289.946 41.7103 274.444 33.3886 259.393C26.1438 246.33 18.7978 232.945 16.4044 218.207C12.7222 195.433 21.5411 172.042 35.3401 153.539C39.49 148.013 44.0209 142.783 48.8998 137.889V221.503C48.8998 223.692 49.7663 225.792 51.3101 227.345C52.8539 228.897 54.9494 229.775 57.1387 229.788H381.623C382.778 235.001 383.282 240.338 383.124 245.676Z",
    fill: "#EBC68F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M261.888 11.3411H175.126C178.391 8.85818 181.938 6.76942 185.694 5.11822C192.552 2.12643 200.027 0.791636 207.483 0.257717C226.244 -1.09549 245.06 3.04698 261.888 11.3411Z",
    fill: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.499 202.245C183.345 203.366 184.361 204.347 185.51 205.154C187.218 206.075 189.098 206.633 191.033 206.792L220.417 211.22C220.709 211.24 220.991 211.335 221.236 211.496C221.399 211.673 221.522 211.883 221.597 212.112C221.672 212.341 221.696 212.583 221.669 212.822C221.805 218.323 221.062 223.812 219.469 229.079C219.385 229.51 219.177 229.906 218.87 230.22C218.474 230.489 218.005 230.63 217.526 230.625C207.64 231.463 197.707 231.196 187.792 230.929C186.126 230.953 184.462 230.77 182.84 230.386C180.078 229.613 177.823 227.726 175.743 225.783C171.278 221.632 153.207 204.942 152.112 202.677C150.659 199.433 149.489 196.07 148.614 192.625C147.693 189.311 154.423 188.897 154.284 185.454C154.187 183.073 154.473 180.693 155.131 178.403C155.621 176.36 156.637 174.481 158.077 172.953C159.09 172.032 157.525 165.791 158.924 165.717C160.544 171.241 167.872 182.287 171.057 187.019C174.597 192.294 178.417 197.377 182.499 202.245Z",
    fill: "#FF7D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.499 202.245C183.345 203.366 184.361 204.347 185.51 205.154C187.218 206.075 189.098 206.633 191.033 206.792L220.417 211.22C220.709 211.24 220.991 211.335 221.236 211.496C221.399 211.673 221.522 211.883 221.597 212.112C221.672 212.341 221.696 212.583 221.669 212.822C221.805 218.323 221.062 223.812 219.469 229.079C219.385 229.51 219.177 229.906 218.87 230.22C218.474 230.489 218.005 230.63 217.526 230.625C207.64 231.463 197.707 231.196 187.792 230.929C186.126 230.953 184.462 230.77 182.84 230.386C180.078 229.613 177.823 227.726 175.743 225.783C171.278 221.632 153.207 204.942 152.112 202.677C150.659 199.433 149.489 196.07 148.614 192.625C147.693 189.311 154.423 188.897 154.284 185.454C154.187 183.073 154.473 180.693 155.131 178.403C155.621 176.36 156.637 174.481 158.077 172.953C159.09 172.032 157.525 165.791 158.924 165.717C160.544 171.241 167.872 182.287 171.057 187.019C174.597 192.294 178.417 197.377 182.499 202.245Z",
    fill: "url(#paint0_linear_13_417)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.147 155.61C106.168 157.374 104.321 159.281 102.623 161.317C98.5545 166.316 95.848 172.263 93.3257 178.191C86.6149 193.969 80.7694 210.843 82.5093 227.901C82.5422 228.927 82.8199 229.931 83.3194 230.828C84.1117 231.843 85.2247 232.561 86.4768 232.862C89.708 233.893 93.16 233.939 96.6029 233.967C109.868 234.087 123.152 234.206 136.407 233.562C138.46 233.461 140.633 233.304 142.336 232.144C143.58 231.192 144.572 229.95 145.226 228.527C148.789 221.825 149.829 214.074 152.591 207.022C156.273 197.817 166.399 189.449 164.263 179.747C155.131 138.552 112.326 151.808 108.147 155.61Z",
    fill: "#FF7D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.147 155.61C106.168 157.374 104.321 159.281 102.623 161.317C98.5545 166.316 95.848 172.263 93.3257 178.191C86.6149 193.969 80.7694 210.843 82.5093 227.901C82.5422 228.927 82.8199 229.931 83.3194 230.828C84.1117 231.843 85.2247 232.561 86.4768 232.862C89.708 233.893 93.16 233.939 96.6029 233.967C109.868 234.087 123.152 234.206 136.407 233.562C138.46 233.461 140.633 233.304 142.336 232.144C143.58 231.192 144.572 229.95 145.226 228.527C148.789 221.825 149.829 214.074 152.591 207.022C156.273 197.817 166.399 189.449 164.263 179.747C155.131 138.552 112.326 151.808 108.147 155.61Z",
    fill: "url(#paint1_linear_13_417)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.093 121.485C166.537 129.043 164.908 136.803 160.728 143.311C159.205 145.939 157.001 148.108 154.349 149.589C151.652 150.943 148.227 151.127 145.705 149.47C144.444 148.65 143.063 147.362 141.691 147.969C140.697 148.42 140.375 149.654 140.237 150.731C139.891 153.377 139.929 156.058 140.347 158.694C140.518 159.436 140.562 160.201 140.476 160.958C140.298 161.658 139.92 162.292 139.389 162.782C138.858 163.272 138.197 163.598 137.484 163.72C136.06 163.927 134.607 163.7 133.314 163.066C131.304 162.167 129.545 160.789 128.19 159.053C126.836 157.316 125.928 155.274 125.545 153.106C125.352 151.641 125.26 150.165 125.269 148.687C125.094 142.133 124.054 135.606 124.265 129.061C124.477 122.516 126.106 115.704 130.553 110.871C133.12 108.239 136.171 106.127 139.537 104.648C144.554 102.255 150.151 100.57 155.638 101.445C157.821 101.789 159.904 102.603 161.742 103.83C163.581 105.057 165.132 106.668 166.288 108.551C169.161 112.961 169.17 116.247 168.093 121.485Z",
    fill: "#FFDAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.8 104.832C182.174 101.76 181.603 98.6475 180.164 95.9079C178.725 93.1682 176.486 90.9317 173.745 89.4959C171.305 88.2808 168.59 87.7653 165.957 87.0657C159.789 85.4087 153.87 82.6654 147.546 82.0763C141.222 81.4871 133.95 83.7057 131.133 89.4407C130.617 90.4901 130.111 91.7605 128.979 92.0366C128.36 92.1032 127.734 92.0469 127.137 91.8709C122.912 91.1253 119.11 94.7339 117.205 98.5725C114.13 104.786 113.974 112.031 114.646 118.926C115.262 125.305 116.892 132.2 122.01 136.085C122.516 136.472 123.262 136.821 123.75 136.407C123.973 136.174 124.112 135.872 124.146 135.551C124.66 133.132 124.852 130.656 124.716 128.187C124.615 126.346 124.321 124.394 124.799 122.58C125.278 120.767 126.815 119.046 128.693 119.101C130.433 119.101 131.832 120.721 132.265 122.415C132.573 124.139 132.507 125.91 132.072 127.607C132.348 128.297 133.314 127.469 133.48 126.751C134.75 120.97 135.036 114.498 139.049 110.181C139.866 111.026 140.461 112.06 140.78 113.191C141.38 112.569 142.143 112.129 142.981 111.921C143.82 111.713 144.7 111.744 145.521 112.013C146.686 112.52 147.756 113.22 148.688 114.084C158.464 121.715 179.747 119.451 181.8 104.832Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.963 165.036C107.87 167.282 106.361 171.231 106.269 175.043C106.177 178.854 110.209 203.036 114.01 209.904C116.956 215.243 123.096 229.18 132.421 233.028C135.183 234.169 176.009 233.691 194.954 231.638C194.835 227.155 194.614 222.672 194.319 218.189C194.347 217.597 194.168 217.015 193.813 216.541C193.334 216.044 192.653 212.794 191.972 212.794C180.925 212.84 169.787 216.219 158.74 216.476C157.136 216.58 155.525 216.484 153.944 216.191C152.65 215.868 151.41 215.36 150.262 214.681C141.737 209.858 137.024 200.385 133.692 191.171C131.142 184.064 129.089 176.709 125.407 170.072C124.1 167.706 122.931 165.404 120.353 164.364C117.324 163.14 113.771 163.002 110.963 165.036Z",
    fill: "#FF7D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.963 165.036C107.87 167.282 106.361 171.231 106.269 175.043C106.177 178.854 110.209 203.036 114.01 209.904C116.956 215.243 123.096 229.18 132.421 233.028C135.183 234.169 176.009 233.691 194.954 231.638C194.835 227.155 194.614 222.672 194.319 218.189C194.347 217.597 194.168 217.015 193.813 216.541C193.334 216.044 192.653 212.794 191.972 212.794C180.925 212.84 169.787 216.219 158.74 216.476C157.136 216.58 155.525 216.484 153.944 216.191C152.65 215.868 151.41 215.36 150.262 214.681C141.737 209.858 137.024 200.385 133.692 191.171C131.142 184.064 129.089 176.709 125.407 170.072C124.1 167.706 122.931 165.404 120.353 164.364C117.324 163.14 113.771 163.002 110.963 165.036Z",
    fill: "url(#paint2_linear_13_417)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.334 211.929C199.069 211.386 205.439 212.665 209.076 217.13C209.458 217.537 209.709 218.051 209.794 218.603C209.79 219.1 209.636 219.585 209.352 219.993C207.207 223.556 202.549 224.402 198.637 225.811C196.601 226.54 194.658 227.504 192.846 228.683C191.827 229.492 190.647 230.076 189.385 230.395C186.623 230.809 184.331 228.342 183.079 225.875C181.643 223.114 179.397 217.443 182.159 214.829C184.414 212.757 190.499 212.187 193.334 211.929Z",
    fill: "#FFDAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.825 210.511C241.846 211.092 242.724 211.894 243.394 212.859C243.721 213.347 243.915 213.912 243.957 214.498C243.999 215.084 243.887 215.671 243.633 216.2C243.199 216.853 242.607 217.385 241.912 217.747C236.821 220.775 230.58 221.319 225.425 224.191C224.367 224.959 223.154 225.487 221.871 225.737C221.117 225.754 220.369 225.596 219.686 225.277C219.003 224.958 218.402 224.485 217.931 223.896C216.992 222.724 216.272 221.393 215.805 219.965C209.775 204.132 232.154 204.988 240.825 210.511Z",
    fill: "#FFDAD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9458 203.442H118.797V223.031C118.797 224.862 118.07 226.618 116.775 227.913C115.48 229.208 113.724 229.935 111.893 229.935H101.85C100.019 229.935 98.2627 229.208 96.968 227.913C95.6732 226.618 94.9458 224.862 94.9458 223.031V203.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.186 208.192H124.413C125.939 208.192 127.402 208.798 128.481 209.877C129.56 210.956 130.166 212.419 130.166 213.945V216.329C130.166 217.855 129.56 219.319 128.481 220.397C127.402 221.476 125.939 222.083 124.413 222.083H117.186V208.192Z",
    stroke: "white",
    strokeWidth: 3.03781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.315 229.511H62.2203C59.3936 229.511 57.1021 231.801 57.1021 234.625C57.1021 237.449 59.3936 239.739 62.2203 239.739H385.315C388.142 239.739 390.433 237.449 390.433 234.625C390.433 231.801 388.142 229.511 385.315 229.511Z",
    fill: "#573400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.921 239.895H143.293V303.238H325.921V239.895Z",
    fill: "#573400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.536 239.895H72.7974V303.238H144.536V239.895Z",
    fill: "#573400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.93 239.895H144.499V303.238H325.93V239.895Z",
    fill: "url(#paint3_linear_13_417)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.536 239.895H72.7974V303.238H144.536V239.895Z",
    fill: "url(#paint4_linear_13_417)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M389.862 19.5801V59.9002H48.8999V19.5801C48.8999 17.3908 49.7664 15.2904 51.3102 13.738C52.854 12.1856 54.9495 11.3073 57.1388 11.2952H381.623C383.813 11.3073 385.908 12.1856 387.452 13.738C388.996 15.2904 389.862 17.3908 389.862 19.5801Z",
    fill: "#934F1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.068 229.337L314.304 229.337C317.618 229.337 320.306 226.649 320.306 223.335C320.306 220.02 317.618 217.333 314.304 217.333L196.068 217.333C192.753 217.333 190.066 220.02 190.066 223.335C190.066 226.649 192.753 229.337 196.068 229.337Z",
    fill: "#E7DFD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.068 229.337L314.304 229.337C317.618 229.337 320.306 226.649 320.306 223.335C320.306 220.02 317.618 217.333 314.304 217.333L196.068 217.333C192.753 217.333 190.066 220.02 190.066 223.335C190.066 226.649 192.753 229.337 196.068 229.337Z",
    fill: "url(#paint5_linear_13_417)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.07 229.355H327.808L351.742 168.663C352.06 167.854 352.176 166.98 352.079 166.117C351.982 165.253 351.676 164.426 351.187 163.708C350.698 162.989 350.041 162.401 349.273 161.994C348.505 161.587 347.65 161.374 346.781 161.372H275.576C272.132 161.379 268.769 162.419 265.923 164.36C263.077 166.3 260.879 169.05 259.614 172.253L237.07 229.355Z",
    fill: "#E7DFD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.682 229.419H327.864L350.592 171.765C350.895 170.997 351.006 170.167 350.915 169.346C350.823 168.525 350.533 167.739 350.068 167.056C349.603 166.374 348.978 165.815 348.248 165.429C347.518 165.044 346.705 164.842 345.879 164.843H278.255C274.979 164.841 271.779 165.826 269.07 167.668C266.361 169.51 264.269 172.124 263.066 175.171L241.682 229.419Z",
    fill: "#E7DFD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.682 229.419H327.864L350.592 171.765C350.895 170.997 351.006 170.167 350.915 169.346C350.823 168.525 350.533 167.739 350.068 167.056C349.603 166.374 348.978 165.815 348.248 165.429C347.518 165.044 346.705 164.842 345.879 164.843H278.255C274.979 164.841 271.779 165.826 269.07 167.668C266.361 169.51 264.269 172.124 263.066 175.171L241.682 229.419Z",
    fill: "url(#paint6_linear_13_417)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M339.251 142.326H211.662V149.506H339.251V142.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.364 130.037H211.662V137.217H302.364V130.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.483 130.037H314.764V137.217H375.483V130.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.272 84.5801H281.919V90.9595H375.272V84.5801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M362.237 95.9121H262.366V102.292H362.237V95.9121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.794 84.5801H213.393V90.9595H274.794V84.5801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.272 106.903H240.328V113.283H375.272V106.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M233.203 106.903H213.393V113.283H233.203V106.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M375.272 118.235H286.199V124.615H375.272V118.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.794 118.235H213.393V124.615H274.794V118.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.875 95.6451H213.393V102.025H252.875V95.6451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.129 63.1038H247.776V69.4832H341.129V63.1038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M328.094 74.4357H228.223V80.8151H328.094V74.4357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.66 63.1038H179.259V69.4832H240.66V63.1038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.3 49.8938H246.947V56.2732H340.3V49.8938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.831 37.9082H178.43V44.2876H239.831V37.9082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.831 26.9722H178.43V33.3516H239.831V26.9722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.741 74.1687H179.259V80.5481H218.741V74.1687Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_417",
    x1: 153.235,
    y1: 191.336,
    x2: 199.493,
    y2: 208.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_417",
    x1: 129.743,
    y1: 242.362,
    x2: 115.704,
    y2: 157.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13_417",
    x1: 134.75,
    y1: 237.649,
    x2: 157.875,
    y2: 185.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13_417",
    x1: 257.653,
    y1: 196.169,
    x2: 218.014,
    y2: 329.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13_417",
    x1: 94.0989,
    y1: 202.484,
    x2: 132.504,
    y2: 384.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13_417",
    x1: 254.937,
    y1: 234.989,
    x2: 255.481,
    y2: 209.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_13_417",
    x1: 294.309,
    y1: 250.472,
    x2: 298.029,
    y2: 156.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 406,
    height: 306,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDeveloper);
export default __webpack_public_path__ + "static/media/Web-developer.ab876093ae2c3bd506db5e0500a1f190.svg";
export { ForwardRef as ReactComponent };